// extracted by mini-css-extract-plugin
export default {"manageSubscription":"styles_manageSubscription__j7L2z"};